import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Product } from '../../../types/Product';
import { analyzeTrends } from '../../../utils/statistics/trends';
import { TrendCard } from './TrendCard';

interface TrendAnalysisProps {
  products: Product[];
}

export const TrendAnalysis: React.FC<TrendAnalysisProps> = ({ products }) => {
  const trends = analyzeTrends(products);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold flex items-center gap-2">
        <TrendingUp className="text-orange-500" size={20} />
        Análisis de Tendencias
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrendCard
          title="Mayores Incrementos"
          items={trends.increases}
          icon={<TrendingUp className="text-red-500" size={20} />}
          trendColor="text-red-500"
        />
        <TrendCard
          title="Mayores Descuentos"
          items={trends.decreases}
          icon={<TrendingDown className="text-green-500" size={20} />}
          trendColor="text-green-500"
        />
      </div>
    </div>
  );
};